// Único sitio del frontend que sabe cómo se escribe una URL de la consola.
//
// Las URL van en inglés y los nombres internos de sección
// (`conversaciones`, `atencion`…) se quedan como están: la traducción vive
// solo aquí. Funciones puras, sin React; `useRutaConsola` las une al router.

// Map y no objeto: con un objeto, `/bots/1/constructor` encontraría la
// propiedad heredada de Object.prototype.
const SLUG_POR_SECCION = new Map([
  ['conversaciones', 'conversations'],
  ['contactos', 'contacts'],
  ['atencion', 'support'],
  ['registros', 'records'],
  ['comentarios-ig', 'instagram-comments'],
  ['whatsapp', 'whatsapp'],
  ['plantillas', 'templates'],
  ['contrato', 'contract'],
  ['configuracion', 'settings'],
]);

const SECCION_POR_SLUG = new Map(
  Array.from(SLUG_POR_SECCION, ([seccion, slug]) => [slug, seccion])
);

const SECCIONES_CON_DETALLE = new Set(['conversaciones', 'contactos', 'atencion', 'registros']);

export const SECCIONES = Array.from(SLUG_POR_SECCION.keys());

const ID_VALIDO = /^[1-9]\d*$/;

const aId = (valor) => {
  const texto = String(valor ?? '');
  if (!ID_VALIDO.test(texto)) return null;
  const id = Number(texto);
  return Number.isSafeInteger(id) ? id : null;
};

export const rutaSelector = () => '/bots';

export const rutaAdmin = () => '/admin';

/**
 * La URL de un destino de la consola. Acepta cualquier forma que devuelva
 * `leerRuta`, así que `rutaDe(leerRuta(url))` normaliza la URL.
 */
export function rutaDe(destino = {}) {
  if (destino.admin) return rutaAdmin();
  if (destino.selector) return rutaSelector();
  const botId = aId(destino.botId);
  if (botId == null) return rutaSelector();
  const slug = SLUG_POR_SECCION.get(destino.seccion);
  if (!slug) return `/bots/${botId}`;
  const detalleId = SECCIONES_CON_DETALLE.has(destino.seccion) ? aId(destino.detalleId) : null;
  return detalleId == null ? `/bots/${botId}/${slug}` : `/bots/${botId}/${slug}/${detalleId}`;
}

/**
 * Lo que dice una URL de la consola, con la sección en su nombre interno, o
 * `null` si no es de la consola. Una sección desconocida no anula la ruta: el
 * bot sí se lee, y quien la consuma decide a qué sección ir.
 */
export function leerRuta(pathname) {
  if (typeof pathname !== 'string') return null;
  const partes = pathname.split('/').filter(Boolean);
  if (partes.length === 1 && partes[0] === 'admin') return { admin: true };
  if (partes[0] !== 'bots' || partes.length > 4) return null;
  if (partes.length === 1) return { selector: true };
  const botId = aId(partes[1]);
  if (botId == null) return null;
  const seccion = SECCION_POR_SLUG.get(partes[2]) ?? null;
  if (partes.length < 4) return { botId, seccion, detalleId: null };
  const detalleId = aId(partes[3]);
  if (detalleId == null) return null;
  if (!SECCIONES_CON_DETALLE.has(seccion)) return { botId, seccion: null, detalleId: null };
  return { botId, seccion, detalleId };
}
